import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dynamicValidator(shouldExecuteValidator: Function, validatorFn: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return shouldExecuteValidator() ? validatorFn(control) : undefined;
  };
}
